import { defineMessages } from 'utils/intl';

export default defineMessages({
  future: 'Przyszłe szkolenia',
  schedule: 'Agenda',
  speakers: 'Prelegenci',
  partners: 'Partnerzy',
  files: 'Dokumenty',
  register: 'Rejestracja',
});
